// Presentation only: dismiss this rendered banner without saving consent.
(() => {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;
  const spacer = document.createElement('div');
  spacer.setAttribute('aria-hidden', 'true');
  banner.before(spacer);
  const reserveSpace = () => {
    const bottom = parseFloat(getComputedStyle(banner).bottom) || 0;
    spacer.style.height = Math.ceil(banner.getBoundingClientRect().height + bottom + 16) + 'px';
  };
  reserveSpace();
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(reserveSpace) : null;
  observer?.observe(banner);
  window.addEventListener('resize', reserveSpace);
  banner.querySelector('[data-cookie-consent-accept]')?.addEventListener('click', () => {
    banner.hidden = true;
    spacer.remove();
    observer?.disconnect();
    window.removeEventListener('resize', reserveSpace);
    // Keep keyboard focus in a predictable place after its button disappears.
    const main = document.getElementById('MainContent');
    if (main) {
      const previousTabindex = main.getAttribute('tabindex');
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
      if (previousTabindex === null) main.removeAttribute('tabindex');
      else main.setAttribute('tabindex', previousTabindex);
    }
  });
})();
